function NodeConfigurationPage() {
    /**
     *
     */
    NodeConfigurationPage.prototype.initialize = function (console) {
        this.id = "nodeConfiguration";
        this.console = console;

        return this;
    };

    /**
     *
     */
    NodeConfigurationPage.prototype.show = function () {
        var deferred = $.Deferred();

        try {
            this.initializeSpeech();

            deferred.resolve();
        }
        catch (error) {
            console.error(error);

            deferred.reject(error)
        }

        return deferred.promise();
    };

    /**
     *
     */
    NodeConfigurationPage.prototype.initializeSpeech = function () {
    };

    /**
     *
     */
    NodeConfigurationPage.prototype.leave = function () {
    };

    /**
     *
     */
    NodeConfigurationPage.prototype.deleteDevice = function (device) {
        this.console.openConfirmationDialog("You are going to delete Device [" + device.label + "]. Please confirm.", function () {
            this.console.deleteDevice(device).done(function () {
                this.console.safeApply();
            }.bind(this)).fail(function (error) {
                this.console.openMessageDialog("Failed to delete Device.", "error");
            }.bind(this));
        }.bind(this));
    };

    /**
     *
     */
    NodeConfigurationPage.prototype.deleteService = function (service) {
        this.console.openConfirmationDialog("You are going to delete Service [" + service.label + "]. Please confirm.", function () {
            this.console.consoleService.deleteService(this.console.node, service).done(function (node) {
                this.console.node = node;

                this.console.safeApply();
            }.bind(this)).fail(function (error) {
                this.console.consoleService.logError(error);
                this.console.openMessageDialog("Failed to delete Service.", "error");
            }.bind(this));
        }.bind(this));
    };

    /**
     *
     */
    NodeConfigurationPage.prototype.deleteGroup = function (group) {
        this.console.openConfirmationDialog("You are going to delete Group [" + group.label + "]. Please confirm.", function () {
            this.console.consoleService.deleteGroup(this.console.node, group).done(function (node) {
                this.console.node = node;

                this.console.safeApply();
            }.bind(this)).fail(function (error) {
                this.console.consoleService.logError(error);
                this.console.openMessageDialog("Failed to delete Group.", "error");
            }.bind(this));
        }.bind(this));
    };

    /**
     *
     */
    NodeConfigurationPage.prototype.deleteEventProcessor = function (eventProcessor) {
        this.console.openConfirmationDialog("You are going to delete Event Processor [" + eventProcessor.label + "]. Please confirm.", function () {
            this.console.consoleService.deleteEventProcessor(this.console.node, eventProcessor).done(function (node) {
                this.console.node = node;

                this.console.safeApply();
            }.bind(this)).fail(function (error) {
                this.console.consoleService.logError(error);
                this.console.openMessageDialog("Failed to delete Event Processor.", "error");
            }.bind(this));
        }.bind(this));
    };

    /**
     *
     */
    NodeConfigurationPage.prototype.deleteStoryboard = function (storyboard) {
        this.console.openConfirmationDialog("You are going to delete Storyboard [" + storyboard.label + "]. Please confirm.", function () {
            this.console.consoleService.deleteStoryboard(this.console.node, storyboard).done(function (node) {
                this.console.node = node;

                this.console.safeApply();
            }.bind(this)).fail(function (error) {
                this.console.consoleService.logError(error);
                this.console.openMessageDialog("Failed to delete Storyboard.", "error");
            }.bind(this));
        }.bind(this));
    };

    /**
     *
     */
    NodeConfigurationPage.prototype.deleteJob = function (job) {
        this.console.openConfirmationDialog("You are going to delete Job [" + job.label + "]. Please confirm.", function () {
            this.console.consoleService.deleteJob(this.console.node, job).done(function (node) {
                this.console.node = node;

                this.console.safeApply();
            }.bind(this)).fail(function (error) {
                this.console.consoleService.logError(error);
                this.console.openMessageDialog("Failed to delete Job.", "error");
            }.bind(this));
        }.bind(this));
    };
}
